module.exports = __webpack_public_path__ + "img/wzf_12.b5db39e7.png";